import ComparisonCards from "components/ComparisonCards";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { ComparisonCardsAdapterProps } from "./ComparisonCards.d";

const ComparisonCardsAdapter = ({
  blok: { content = [] },
  sbEditable,
}: ReactStoryblokComponent<ComparisonCardsAdapterProps>) => (
  <ComparisonCards content={content} sbEditable={sbEditable} />
);
export default ComparisonCardsAdapter;
